module.exports = __webpack_public_path__ + "static/media/racivid.82250190.mp4";